module.exports = __webpack_public_path__ + "assets/img/24_1071.f1a14c2f.jpg";